module.exports = __webpack_public_path__ + "img/logoprosegurBlanco.ae1d3cc1.svg";